import { publicRoutes } from 'app/configs/routes';
import { isWindow } from 'app/utils';
import { refreshToken } from 'app/utils/refreshToken';
import Axios from 'axios';
import queryString from 'query-string';
import BACKEND_URL from 'store/constants/urls';
import store from 'store/index';

import { createErrorInterceptor } from './interceptors';

export { getBackoffTime } from './retryPolicy';

const axios = Axios.create({
  baseURL: BACKEND_URL,
  paramsSerializer: params =>
    queryString.stringify(params, { arrayFormat: 'comma' }),
});

axios.interceptors.request.use((request: any) => {
  const { user } = store.getState();

  let isAuthenticatedRoute;

  if (isWindow()) {
    const { pathname } = window.location;
    isAuthenticatedRoute = !publicRoutes.some(route =>
      pathname.includes(route.path)
    );
  } else {
    isAuthenticatedRoute = true;
  }

  if (isAuthenticatedRoute) {
    axios.defaults.withCredentials = true;
    request.headers.Authorization = `Bearer ${user.accessToken}`;
  } else {
    axios.defaults.withCredentials = false;
  }

  return request;
});

axios.interceptors.response.use(
  response => response,
  createErrorInterceptor(axios, {
    refreshToken: () => refreshToken(),
    setAuthHeader: token => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
  })
);

export { axios as axiosInstance };
